<template>
	<aside class="product-aside sticky-column">
		<section class="section" v-for="(list, index) in productLists" :key="'accessories-'+index">
			<h2>{{ list.title }}</h2>
			<product-tip-slider
				:products="list.products"
				:showBuyBtn="false"
				:loop="false"
				:showStock="false"
				parentElement="product"
				showProgressBar
				compact
			/>
		</section>
		<recently-viewed v-if="showRecentlyViewed" compactCarousel productPage />
	</aside>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import store from 'datastore';
import Vue from 'vue';
import bus from 'eventbus';
import stickyColumn from 'vue-mixins/sticky-column';
import { trackImpression } from 'gtm';

export default {
	mixins: [stickyColumn],
	store,
	data () {
		return {
			TIP_MODE_GRID: 1,
		};
	},
	props: ['productLists'],
	methods: {
		updateList (lists) {
			this.lists = lists || [];
		},
	},
	computed: {
		showRecentlyViewed () {
			return this.productTipsEngine !== 'voyadoElevate';
		},
		lists () {
			const lists = [];
			if (this.showLists) {
				for (const list of this.rightColLists) {
					if (list.products.length) {
						lists.push(list);
						trackImpression(list.products, list.title, { rating: true });
					}
				}
			}
			return lists;
		},
		...mapGetters({
			rightColLists: 'productTips/rightColLists',
			showTopLists: 'productTips/showTopLists',
			showLists: 'productTips/showLists',
			isLoggedIn: 'user/isLoggedIn',
		}),
		...mapState({
			productTipsEngine: state => state.productTips.productTipsEngine,
		}),
	},
	watch: {
		lists (lists) {
			Vue.nextTick(() => {
				bus.$emit('productTips:rendered');
			});
		},
	},
};
</script>
